<template>
  <section class="sitemap">
    <h2>網站導覽</h2>
    <div class="paragraph">
      <h3 class="important-text">
        本網站依無障礙網頁設計原則建置，網站的主要內容分為四大區塊：
      </h3>
      <p>
        1.上方功能區塊、2.中央內容區塊、3.下方選單連結區塊
        本網站的快速鍵﹝Accesskey﹞設定如下：
        Alt+U：選單連結區塊，此區塊列有本網站主要連結。
        Alt+C：中央內容區塊，為本頁主要內容區。 Alt+Z：頁尾網站資訊。
        如果您的瀏覽器是Firefox，快速鍵的使用方法是 Shift+Alt+(快速鍵字母)，例如
        Shift+Alt+C會跳至網頁中央區塊，以此類推。
      </p>
      <ol class="siteLists">
        <li class="list" v-for="(list, index) in sitemapLists" :key="index">
          <router-link
            class="important-text"
            :to="list.routeTo"
            :aria-label="list.ariaLabel"
            :title="`[前往]${list.ariaLabel}`"
          >
            {{ list.content }}
          </router-link>
          <ol v-if="list.routes">
            <li v-for="(route, childIndex) in list.routes" :key="childIndex">
              <router-link
                class="important-text"
                :to="route.routeTo"
                :aria-label="route.ariaLabel"
                :title="`[前往]${route.ariaLabel}`"
              >
                {{ route.content }}
              </router-link>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  </section>
</template>
<script>
export default {
  content: 'ArticleSitemap',
  props: {},
  data() {
    return {
      sitemapLists: [
        {
          content: '參觀導覽',
          routeTo: { name: 'temples' },
          ariaLabel: '參觀導覽',
        },
        {
          content: '藝品導覽',
          routeTo: { name: 'artworks' },
          ariaLabel: '藝品導覽',
        },
        {
          content: '旅遊導覽',
          routeTo: { name: 'themes' },
          ariaLabel: '旅遊導覽',
        },
        {
          content: '圖鑑集',
          routeTo: { name: 'albums' },
          ariaLabel: '圖鑑集',
        },
        {
          content: '標籤檢索',
          routeTo: { name: 'tags' },
          ariaLabel: '標籤檢索',
        },
        {
          content: '香科年專區',
          routeTo: { name: 'festivalYear' },
          ariaLabel: '香科年專區',
          routes: [
            {
              content: '香科年介紹',
              routeTo: { name: 'festivalYearFestivalList' },
              ariaLabel: '香科年介紹',
            },
            // {
            //   content: '相關課程',
            //   routeTo: { name: 'festivalYearSkillList' },
            //   ariaLabel: '相關課程',
            // },
            {
              content: '活動資訊',
              routeTo: { name: 'festivalYearInformationList' },
              ariaLabel: '活動資訊',
            },
            {
              content: '歷史回顧',
              routeTo: { name: 'festivalYearHistory' },
              ariaLabel: '歷史回顧',
            },
            // {
            //   content: '最新消息',
            //   routeTo: { name: 'festivalYearNewsList' },
            //   ariaLabel: '最新消息',
            // },
            {
              content: 'English',
              routeTo: { name: 'festivalYearEnglishList' },
              ariaLabel: 'English',
            },
          ],
        },
        {
          content: '我的收藏',
          routeTo: { name: 'favourite' },
          ariaLabel: '我的收藏',
        },
        {
          content: '登入',
          routeTo: { name: 'login' },
          ariaLabel: '會員登入',
        },
        {
          content: '搜尋',
          routeTo: { name: 'searchInput' },
          ariaLabel: '搜尋',
        },
      ],
    };
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.sitemap {
  line-height: 2;

  @include for-tablet {
    padding: 0 50px;
  }

  h2 {
    color: $color-light-title;
    text-align: center;
    letter-spacing: 1.71px;
    font-size: 1.75rem;
    margin: 0;
  }
}
.paragraph {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
  padding: 0 10px;
  padding-top: 22px;
  padding-bottom: 20px;

  .important-text {
    color: $color-light-description;
    font-size: 1.125rem;
    line-height: 1.5;
    letter-spacing: 1px;
    margin: 0;
  }

  > p {
    color: $color-light-description;
    font-size: 1rem;
    margin-top: 0;
    margin-bottom: 15px;
    white-space: pre-line;
    text-align: justify;
    text-align-last: left;
  }
}

ol {
  counter-reset: item;
  > li {
    counter-increment: item;
  }
}

.siteLists {
  margin-top: 20px;

  > .list {
    a {
      text-decoration: underline;
    }
  }

  ol > li {
    display: block;

    &:before {
      content: counters(item, ".") ".";
      margin-left: -20px;
    }
  }
}
</style>
